import Files696f8 from "./components/InvoiceIncoming/Files";
import Totals5ff3a from "./components/PaymentsImport/Totals";
import Files7a482 from "./components/InvoiceOutgoing/Files";
export const CustomListComponentsMap: any = {
    'customlist.InvoiceIncoming/Files': Files696f8,
    'customlist.PaymentsImport/Totals': Totals5ff3a,
    'customlist.InvoiceOutgoing/Files': Files7a482,
}